import Series from './Series';
import provideAxis from '../AxisProvider';
export default provideAxis(Series);